import React from "react";
import ToggleTheme from "../ToggleTheme/ToggleTheme";
import LoggedInCard from "../LoggedInCard/LoggedInCard";
import { useIsAuthenticated } from "@azure/msal-react";
import { IS_DACHSER } from "../../constants";
import "./AppHeader.css"

const AppHeader: React.FC = () => {
    const isAuthenticated = useIsAuthenticated();

    return (
        <header className="header">
            {IS_DACHSER &&( 
            <img
                src="https://upload.wikimedia.org/wikipedia/commons/d/d8/Dachser_Logo_2021.svg"
                alt="Dachser Logo"
                className="logo"
            />)}

            <div className="rightSide">
                <ToggleTheme />
                {isAuthenticated && <LoggedInCard />}
            </div>
        </header>
    );
};

export default AppHeader;
